// src/viewmodels/usePortfolioViewModel.js
// VIEWMODEL — business logic & state management

import { useState, useCallback } from 'react';
import { projects, filterTabs } from '../models/portfolioData';

export function usePortfolioViewModel() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const filteredProjects =
    activeFilter === 'all'
      ? projects
      : projects.filter((p) => p.tags.includes(activeFilter));

  const handleFilterChange = useCallback((filter) => {
    setActiveFilter(filter);
  }, []);

  const openProjectDetails = useCallback((project) => {
    setSelectedProject(project);
    setIsDetailsOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeProjectDetails = useCallback(() => {
    setIsDetailsOpen(false);
    document.body.style.overflow = '';
    setTimeout(() => setSelectedProject(null), 300);
  }, []);

  return {
    activeFilter,
    filteredProjects,
    filterTabs,
    selectedProject,
    isDetailsOpen,
    handleFilterChange,
    openProjectDetails,
    closeProjectDetails,
  };
}
